module.exports = __webpack_public_path__ + "static/media/2_pl.e56ca85c.png";